import { makeAutoObservable } from 'mobx';
import { ATTENDEES_LIMIT_PER_PAGE } from '../../constans/attendees-constants';
import { getMixpanelService } from '../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../constans/mixpanel-contants';

const ONE = 1;

interface IPagingStore {
    getCurrentPage: () => void;
    getPageSize: () => void;
    getTotalRecords: () => void;
    getTotalPages: () => void;
    next: () => void;
    prev: () => void;
    selectPage: (newPage: number) => void;
    setTotalRecords: (newRecords: number) => void;
}

interface IPagingInit {
    pageNumber: number;
    pageSize: number;
    pageSizeOptions: number[];
    totalRecords: number;
}

const defaultSettings = {
  pageSize: ATTENDEES_LIMIT_PER_PAGE,
  pageSizeOptions: [],
  pageNumber: ONE,
  totalRecords: 0,
  withChooser: false
};

class PagingStore implements IPagingStore {
  private totalPages: number;
  private totalRecords: number;
  private currentPage: number;
  private pageSize: number;

  constructor (
    fromDTO?: Partial<IPagingInit>
  ) {
    makeAutoObservable(this);
    this.currentPage = fromDTO?.pageNumber || defaultSettings.pageNumber;
    this.totalRecords = fromDTO?.totalRecords || defaultSettings.totalRecords;
    this.pageSize = fromDTO?.pageSize || defaultSettings.pageSize;

    this.setTotalPagesSize();
  }

  public getCurrentPage = (): number => {
    return this.currentPage;
  };

  public getCurrentPageForBE = (): number => {
    return this.currentPage - ONE;
  };

  public getPageSize = (): number => {
    return this.pageSize;
  };

  public getTotalRecords = (): number => {
    return this.totalRecords;
  };

  public getTotalPages = (): number => {
    return this.totalPages;
  };

  public next = (): void => {
    if (this.currentPage === this.totalPages) {
      return;
    }

    this.currentPage++;

    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.ATTENDEES, MIXPANEL_EVENT_TYPES.PAGING);
  };

  public prev = (): void => {
    if (this.currentPage === ONE) {
      return;
    }

    this.currentPage--;

    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.ATTENDEES, MIXPANEL_EVENT_TYPES.PAGING);
  };

  public selectPage = (newPage: number): void => {
    if (newPage === this.currentPage) {
      return;
    }

    this.currentPage = newPage;

    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.ATTENDEES, MIXPANEL_EVENT_TYPES.PAGING);
  };

  public setTotalRecords = (newRecords: number): void => {
    this.totalRecords = newRecords;
    this.setTotalPagesSize();
  };

  private setTotalPagesSize = (): void => {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
  };
}

export { PagingStore };
